module.exports = __webpack_public_path__ + "img/earth.20505e24.svg";